import { useEffect, useRef, useState } from "react";

export function useTransitionPresence(isOpen: boolean, onExit?: () => void) {
  const [shouldRender, setShouldRender] = useState(isOpen);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    // If opening → mount immediately
    if (isOpen) {
      setShouldRender(true);
      return;
    }

    // If closing → wait for transition to finish
    const handleEnd = () => {
      setShouldRender(false);
      onExit?.();

      el.removeEventListener("transitionend", handleEnd);
    };

    el.addEventListener("transitionend", handleEnd);

    // cleanup if unmounted early
    return () => el.removeEventListener("transitionend", handleEnd);
  }, [isOpen]);

  return { ref, shouldRender };
}
